import useResize from './hooks/useResize'
import useDebug from './hooks/useDebug'
import useMobileNav from './hooks/useMobileNav'
import usePlyrVideo from './hooks/usePlyrVideo'
import useLenisScroll from './hooks/useLenisScroll'
import useManageScrollHeader from './hooks/useManageScrollHeader'
import useManageEvents from './hooks/useManageEvents'
import useScrollAnimations from './hooks/useScrollAnimations'
import useScrollbar from './hooks/useScrollbar'
import useCarousels from './hooks/useCarousels'

document.addEventListener('DOMContentLoaded', () => {
  useResize()
  useDebug()
  useMobileNav()
  usePlyrVideo()
  useLenisScroll()
  useManageScrollHeader()
  useManageEvents()
  useScrollAnimations()
  useScrollbar()
  useCarousels()
})
